import { useState } from "react";
import { Box } from "@mui/material";
import { PageHeader } from "../../components/ui";
import AssignTaskForm from "./AssignTaskForm";
import ManualTaskAssignmentReport from "./ManualTaskAssignmentReport";

export default function ClioMatterInteraction() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Box sx={{ width: "100%" }}>
      <PageHeader
        title="Assign tasks"
        subtitle="Assign tasks in Clio and review recent manual assignments."
      />

      <AssignTaskForm onAssigned={() => setRefreshKey((key) => key + 1)} />
      <ManualTaskAssignmentReport refreshKey={refreshKey} />
    </Box>
  );
}
